import axios from '../localAxios';
import { renameFoldersUrl } from './url';

interface RenameFolderParam {
  name: string;
  folderId: number;
}

export async function renameFolder({ name, folderId }: RenameFolderParam) {
  const url = renameFoldersUrl(folderId);
  const { data } = await axios.put<Record<string, never>>(url.href, { name });
  return data;
}
